export function jobTitle(job: { normalized_title?: string; title?: string }) {
  return job.normalized_title || job.title || "Untitled role";
}

export function compactNumber(value: number) {
  return new Intl.NumberFormat("en-IN", {
    notation: value >= 1000 ? "compact" : "standard",
    maximumFractionDigits: value >= 1000 ? 1 : 0,
  }).format(value);
}

export function fullNumber(value: number) {
  return new Intl.NumberFormat("en-IN").format(value);
}

export function formatSalary(job: {
  salary?: unknown;
  salary_min?: number | null;
  salary_max?: number | null;
  salary_currency?: string | null;
  salary_rate_unit?: string | null;
}) {
  if (typeof job.salary === "string" && job.salary.trim()) return job.salary;
  if (typeof job.salary === "number") return `₹${fullNumber(job.salary)}`;

  const low = job.salary_min;
  const high = job.salary_max;
  if (!low && !high) return "";

  const currency = job.salary_currency === "INR" || !job.salary_currency ? "₹" : `${job.salary_currency} `;
  const range = [low, high]
    .filter((value): value is number => typeof value === "number")
    .map(fullNumber)
    .join("–");
  const unit = job.salary_rate_unit ? ` / ${job.salary_rate_unit}` : "";
  return `${currency}${range}${unit}`;
}

export function relativeDate(timestamp?: number) {
  if (!timestamp) return "Recently verified";
  const date = new Date(timestamp * 1000);
  if (Number.isNaN(date.getTime())) return "Recently verified";

  const today = new Date();
  const day = 86_400_000;
  const diff = Math.max(0, Math.floor((today.getTime() - date.getTime()) / day));
  if (diff === 0) return "Verified today";
  if (diff === 1) return "Verified yesterday";
  if (diff < 7) return `Verified ${diff} days ago`;
  return "Active listing";
}

export function initials(company?: string) {
  const words = (company || "Employer").trim().split(/\s+/).filter(Boolean);
  return words.slice(0, 2).map((word) => word[0]).join("").toUpperCase();
}

export function stringList(value?: string | string[] | null) {
  if (Array.isArray(value)) return value.filter(Boolean);
  return value ? [value] : [];
}
